import {LOCALE_ID, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {AccordionComponent} from '../ui-components/accordion/accordion.component';
import {AlertComponent} from '../ui-components/alert/alert.component';
import {BadgeComponent} from '../ui-components/badge/badge.component';
import {ButtonComponent} from '../ui-components/button/button.component';
import {CardsComponent} from '../ui-components/cards/cards.component';
import {DropdownComponent} from '../ui-components/dropdown/dropdown.component';
import {ListGroupComponent} from '../ui-components/list-group/list-group.component';
import {ModalComponent} from '../ui-components/modal/modal.component';
import {ProgressBarComponent} from '../ui-components/progress-bar/progress-bar.component';
import {TabComponent} from '../ui-components/tab/tab.component';
import {SweetAlertComponent} from '../ui-components/sweet-alert/sweet-alert.component';
import {ToastrComponent} from '../ui-components/toastr/toastr.component';
import {DateComponent} from '../ui-components/forms/filters/date/date.component';
import {InputComponent} from '../ui-components/forms/input/input.component';
import {SelectComponent} from '../ui-components/forms/select/select.component';
import {MainLayoutComponent} from '../layout/main-layout/main-layout.component';
import {SidebarComponent} from '../layout/sidebar/sidebar.component';
import {HeaderComponent} from '../layout/header/header.component';
import {BreadcrumbComponent} from '../layout/breadcrumb/breadcrumb.component';
import {FooterComponent} from '../layout/footer/footer.component';
import {ErrorComponent} from '../layout/errors/error.component';
import {ResourceNotFoundComponent} from '../layout/errors/resource-not-found/resource-not-found.component';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AppMessageService} from './services/app-message/app-message.service';
import {AppAlertService} from './services/app-alert/app-alert.service';
import {AuthServiceModule} from './services/auth/auth.module';
import {EmptyDataComponent} from '../ui-components/empty-data/empty-data.component';
import {SortPipe} from './pipes/sort.pipe';
import {NgInitDirective} from './decorators/ng-init.decorator';
import {NgChangeDirective} from './decorators/ng-change.decorator';
import {GroupByPipe} from './pipes/group-by.pipe';
import {FilterByPipe, FilterQ, GlobalSearchPipe} from './pipes/filter.pipe';
import {ParameterService} from './services/parameter/parameter.service';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {KeyFormatDirective} from './directives/key-format.directive';
import {CorePopupComponent} from '../ui-components/core-popup/core-popup.component';
import {CoreOffcanvasComponent} from '../ui-components/core-offcanvas/core-offcanvas.component';
import {CoreMultiSelectComponent} from '../ui-components/core-multiselect/core-multiselect.component';
import {CoreDropdownComponent} from '../ui-components/core-dropdown/core-dropdown.component';
import {AddressAutocompleteComponent} from '../ui-components/address-autocomplete/address-autocomplete.component';
import {TableModule} from 'primeng/table';
import {TableComponent} from '../ui-components/table/table.component';
import {SkeletonModule} from 'primeng/skeleton';
import {PaginatorModule} from 'primeng/paginator';
import {LoadingComponent} from '../ui-components/loading/loading.component';
import {DividerModule} from 'primeng/divider';
import {DateFormatPipe} from './pipes/date.pipe';
import {CalendarModule} from 'primeng/calendar';
import {CalendarLanguageService} from './services/primeng/calendar';
import {ArrayKeysPipe} from './pipes/array-keys.pipe';
import {MernisQueryComponent} from './components/mernis-query/mernis-query.component';
import {FilterContainerComponent} from '../ui-components/filter-container/filter-container.component';
import {CoreChipsComponent} from '../ui-components/core-chips/core-chips.component';
import {DialogModule} from 'primeng/dialog';
import {DropdownModule} from 'primeng/dropdown';
import {MultiSelectModule} from 'primeng/multiselect';
import {SidebarModule} from 'primeng/sidebar';
import {IcdCodeListComponent} from './components/icd-code/icd-code-list/icd-code-list.component';
import {ArrayValuesPipe} from './pipes/array-values.pipe';
import {CoreInfoMessagesComponent} from '../ui-components/core-info-messages/core-info-messages.component';
import {ChipsModule} from 'primeng/chips';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import {PhoneNumbersComponent} from './components/phone-numbers/phone-numbers.component';
import {InputGroupModule} from 'primeng/inputgroup';
import {InputGroupAddonModule} from 'primeng/inputgroupaddon';
import {ButtonModule} from 'primeng/button';
import {SafeHtmlPipe} from './pipes/safe-html.pipe';
import {EditorModule} from 'primeng/editor';
import {FileUploadDialogComponent} from '../pages/announcement/admin/create/add-file-modal/add-file-modal.component';
import {CoreAccordionComponent} from '../ui-components/core-accordion/core-accordion.component';
import {ColorPickerModule} from 'primeng/colorpicker';
import {PreventNegativeInputDirective} from './directives/number-input-letter-validaton.directive';
import {MedicalAdviceComponent} from './components/medical-advice/medical-advice.component';
import {CheckboxModule} from 'primeng/checkbox';
import {ExcelComponent} from '../ui-components/excel/excel.component';
import {ProgressBarModule} from 'primeng/progressbar';
import {TooltipModule} from 'primeng/tooltip';
import {NumberCommaFormatPipe} from './pipes/number-comma.pipe';
import {FileUploadModule} from 'primeng/fileupload';
import {SidebarMessageCanvasComponent} from '../layout/sidebar-message/sidebar-message.component';
import {
  SidebarAnnouncementCanvasComponent
} from '../pages/announcement/user/sidebar-announcement/sidebar-announcement.component';
import {AnnouncementModalComponent} from '../pages/announcement/user/announcement-modal/announcement.component';
import {PhoneListComponent} from './components/phone-list/phone-list.component';
import {EmailListComponent} from './components/email-list/email-list.component';
import {AddressListComponent} from './components/address-list/address-list.component';
import {AlphanumericInputDirective} from './directives/alphanumeric-input.directive';
import {MedicalRecordsComponent} from './components/medical-records/medical-records.component';
import {CurrencyFormatterDirective} from './directives/currency-formatter.directive';
import {TreeModule} from 'primeng/tree';
import {IcdCodesPopupComponent} from './components/icd-code/icd-codes-popup/icd-codes-popup.component';
import {ICDGroupComponent} from '../pages/icd-groups/icd-group.component';
import {StepsModule} from 'primeng/steps';
import {PatientCardComponent} from './components/patient-card/patient-card.component';
import {PatientCreateComponent} from '../pages/definition/patient/patient-create/patient-create.component';
import {GenderPipe} from './pipes/gender.pipe';
import {HasPermissionDirective} from './directives/has-permission.directive';
import {HasPermissionPipe} from './pipes/has-permission.pipe';
import {
  RoleAssignDetailComponent
} from '../pages/management/authorization-management/components/roles/role-assign-detail/role-assign-detail.component';
import {TextLimiterPipe} from './pipes/text-truncate.pipe';
import {AddressInputComponent} from '../ui-components/address-autocomplete/address-input/address-input.component';
import {PhoneMaskPipe} from './pipes/phone-mask.pipe';
import {NgxMaskDirective, provideNgxMask} from 'ngx-mask';
import {CallReceivingPopupComponent} from './components/call-receiving-popup/call-receiving-popup.component';
import {CallService} from './services/call/call.service';
import {
  RegionDistrictDescriptionComponent
} from '../pages/definition/region/description-modal/region-district-desription-modal';
import {GoogleAutocompleteDirective} from './directives/address.directive';
import {ClipboardModule} from 'ngx-clipboard';
import {ServicePricePopupComponent} from './components/service-price-popup/service-price-popup.component';
import {CurrencyComponent} from './components/currency/currency.component';
import {TimelineModule} from 'primeng/timeline';
import {CaseAssignVehicleComponent} from './components/case-assign-vehicle/case-assign-vehicle.component';
import {ChangeKdvRatesComponent} from './components/change-kdv-rates/change-kdv-rates.component';
import {CallUploadFileComponent} from './components/call-upload-file/call-upload-file-dialog.component';
import {
  CoreFileUploadDialogComponent
} from '../pages/organization/organization-create/create-organization-tab-three/add-file-modal/add-file-modal.component';
import {ReadonlyInputComponent} from '../ui-components/readonly-input/readonly-input.component';
import {CallTimerComponent} from '../ui-components/call-timer/call-timer.component';
import {CallButtonComponent} from '../ui-components/call-button/call-button.component';
import {
  SidebarLastCallsCanvasComponent
} from '../pages/announcement/user/sidebar-last-calls/sidebar-last-calls.component';
import {CallViewPopupComponent} from './components/call-card-view-popup/call-card-view-popup.component';
import {
  MemberInputComponent
} from '../pages/case/components/case-card/components/case-informations/components/member-input/member-input.component';
import {InputNumberModule} from 'primeng/inputnumber';
import {ToggleButtonModule} from 'primeng/togglebutton';
import {IcdCodeDropdownComponent} from '../ui-components/icd-code-dropdown/icd-code-dropdown.component';
import {VehicleLocationMapComponent} from './components/vehicle-location-map/vehicle-location-map.component';
import {DynamicDivColorDirective} from './directives/dynamic-div-color.directive';
import {DashboardMapComponent} from './components/dashboard-map/dashboard-map.component';
import {MapLocationInfoComponent} from './components/dashboard-map/map-location-info/map-location-info.component';
import {
  PatientInfoCardComponent
} from './components/dashboard-map/map-location-info/patient-info-card/patient-info-card.component';
import {
  MapSearchNavigationComponent
} from './components/dashboard-map/map-search-navigation/map-search-navigation.component';
import {WatchTeamMembersCardComponent} from './components/watch-team-members-card/watch-team-members-card.component';
import {MinutesAgoPipe} from './pipes/minutes-ago.pipe';
import {
  OrganizationAssignVehicleComponent
} from './components/organization-assign-vehicle/organization-assign-vehicle.component';
import {OrganizationStatusPipe} from './pipes/organization-status-pipe';
import {CaseStatusPipe} from './pipes/case-status.pipe';
import {AppointmentStatusPipe} from './pipes/appointment-status.pipe';
import {LabmedLogsComponent} from '../pages/case/components/case-integration-card/labmed-logs/labmed-logs.component';
import {MyReportsComponent} from '../pages/reports/my-reports/my-reports.component';
import {DistancePipe} from './pipes/distance-to.pipe';
import {TooltipDirective} from './directives/tooltip.directive';
import {
  ShowOrganizationLogComponent
} from '../pages/mobile-status/organizations/components/show-organization-log/show-organization-log.component';
import {FilterByValueObjectPipe} from "./pipes/filter-by-value-object.pipe";
import {
  CaseFeatureInformationsComponent
} from '../pages/case/components/case-card/components/tab-header-components/case-feature-informations/case-feature-informations.component';
import {ShortcutComponent} from "./components/shortcut/shortcut.component";
import {
  CaseFeatureInputs
} from "../pages/case/components/case-card/components/tab-header-components/case-feature-informations/components/case-feature-inputs/case-feature-inputs.component";
import {PhoneMaskTRDirective} from "./directives/phone-mask-tr.directive";
import {CreateCaseSummaryComponent} from "./components/create-case-summary/create-case-summary.component";
import {PaymentButtonComponent} from "./components/payment-button/payment-button.component";
import {
  CaseDocumentsComponent
} from "../pages/case/components/case-card/components/tab-header-components/case-documents/case-documents.component";
import {BillStatusPipe} from "../pages/bills/bill-status.pipe";
import {
  SendBillDocumentEmailComponent
} from "../pages/bills/component/sub-components/send-bill-document-email/send-bill-document-email.component";
import {SearchModule} from "./components/search/search.module";
import {MenuModule} from 'primeng/menu';
import {AppToggleAccordionComponent} from './components/app-toggle-accordion/app-toggle-accordion.component';
import {PasswordChangePopupComponent} from "./components/password-change-popup/password-change-popup.component";
import { AssignUserDialogComponent } from '../pages/mobile-status/without-team/assign-user-dialog/assign-user-dialog.component';
import { SendMailSmsComponent } from '../ui-components/send-mail-sms/send-mail-sms.component';
import { CaseTimelineComponent } from '../pages/case/components/case-card/components/tab-header-components/case-timeline/case-timeline.component';
import {PhonePopoverDirective} from "./directives/phone-popover.directive";
import { PatientInformationsComponent } from '../pages/case/components/case-card/components/patient-informations/patient-informations.component';
import { PatientEmailPopupComponent } from '../pages/case/components/case-card/components/patient-informations/patient-email-popup/patient-email-popup.component';
import { PatientPhonePopupComponent } from '../pages/case/components/case-card/components/patient-informations/patient-phone-popup/patient-phone-popup.component';
import { SecondaryLayoutComponent } from '../layout/secondary-layout/secondary-layout.component';
import { HeaderSecondaryComponent } from '../layout/header-secondary/header-secondary.component';

@NgModule({
  declarations: [
    /*   ui-components   */
    AccordionComponent,
    AlertComponent,
    BadgeComponent,
    ButtonComponent,
    CardsComponent,
    DropdownComponent,
    ListGroupComponent,
    ModalComponent,
    ProgressBarComponent,
    TabComponent,
    SweetAlertComponent,
    ToastrComponent,
    DateComponent,
    InputComponent,
    SelectComponent,
    AddressAutocompleteComponent,
    AddressInputComponent,
    FileUploadDialogComponent,

    /*  layout-components  */
    MainLayoutComponent,
    SecondaryLayoutComponent,
    SidebarComponent,
    SidebarMessageCanvasComponent,
    SidebarAnnouncementCanvasComponent,
    AnnouncementModalComponent,
    HeaderComponent,
    HeaderSecondaryComponent,
    MyReportsComponent,
    BreadcrumbComponent,
    FooterComponent,
    ErrorComponent,
    ResourceNotFoundComponent,
    EmptyDataComponent,
    SortPipe, ArrayKeysPipe, ArrayValuesPipe, MinutesAgoPipe, FilterQ, DistancePipe,GlobalSearchPipe,
    GroupByPipe,
    NgInitDirective,
    NgChangeDirective,
    FilterByPipe,
    SafeHtmlPipe,
    KeyFormatDirective,
    GoogleAutocompleteDirective,
    CoreDropdownComponent,
    CoreMultiSelectComponent,
    CoreOffcanvasComponent,
    CorePopupComponent,
    ShortcutComponent,

    /*  shared/components  */
    MernisQueryComponent,
    LoadingComponent,
    DateFormatPipe,
    IcdCodeListComponent,
    FilterContainerComponent,
    CoreChipsComponent,
    TableComponent,
    CoreInfoMessagesComponent,
    CoreAccordionComponent,
    PreventNegativeInputDirective,
    PhoneNumbersComponent,
    MedicalAdviceComponent,
    ExcelComponent,
    IcdCodesPopupComponent,
    ICDGroupComponent,
    NumberCommaFormatPipe,
    PhoneListComponent,
    EmailListComponent,
    AddressListComponent,
    AlphanumericInputDirective,
    CurrencyFormatterDirective,
    MedicalRecordsComponent,
    PatientCardComponent,
    PatientCreateComponent,
    GenderPipe,
    HasPermissionDirective,
    HasPermissionPipe,
    RoleAssignDetailComponent,
    TextLimiterPipe,

    /*Logs*/
    CaseTimelineComponent,
    /*Calls*/
    RegionDistrictDescriptionComponent,
    PhoneMaskPipe,
    ServicePricePopupComponent,
    ChangeKdvRatesComponent,
    CurrencyComponent,
    CaseAssignVehicleComponent,
    CallUploadFileComponent,
    CoreFileUploadDialogComponent,
    CallTimerComponent,
    /*Calls*/
    CallReceivingPopupComponent,
    CallButtonComponent,
    SidebarLastCallsCanvasComponent,
    CallViewPopupComponent,
    ReadonlyInputComponent,
    MemberInputComponent,
    IcdCodeDropdownComponent,
    VehicleLocationMapComponent,
    DynamicDivColorDirective,
    DashboardMapComponent,
    MapLocationInfoComponent,
    PatientInfoCardComponent,
    MapSearchNavigationComponent,
    WatchTeamMembersCardComponent,
    OrganizationAssignVehicleComponent,
    OrganizationStatusPipe,
    CaseStatusPipe,
    AppointmentStatusPipe,
    FilterByValueObjectPipe,
    LabmedLogsComponent,
    TooltipDirective,
    ShowOrganizationLogComponent,
    CaseFeatureInformationsComponent,
    PhoneMaskTRDirective,
    CreateCaseSummaryComponent,
    CaseFeatureInputs,
    PaymentButtonComponent,
    CaseDocumentsComponent,
    BillStatusPipe,
    SendBillDocumentEmailComponent,
    AppToggleAccordionComponent,
    SendMailSmsComponent,
    PasswordChangePopupComponent,
    AssignUserDialogComponent,
    PhonePopoverDirective,
    PatientInformationsComponent,
    PatientEmailPopupComponent,
    PatientPhonePopupComponent,

  ],
  imports: [
    CommonModule,
    HttpClientModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    AuthServiceModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      defaultLanguage: 'tr',
    }),
    TableModule,
    SkeletonModule,
    PaginatorModule,
    DividerModule,
    CalendarModule,
    DialogModule,
    DropdownModule,
    MultiSelectModule,
    SidebarModule,
    ChipsModule,
    OverlayPanelModule,
    InputGroupModule,
    InputGroupAddonModule,
    ButtonModule,
    EditorModule,
    ProgressBarModule,
    TooltipModule,
    ColorPickerModule,
    FileUploadModule,
    TreeModule,
    StepsModule,
    ClipboardModule,
    TimelineModule,
    InputNumberModule,
    ToggleButtonModule,
    SearchModule,
    MenuModule,
    NgxMaskDirective,
  ],

  exports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    RouterModule,
    TranslateModule,
    ReactiveFormsModule,
    AuthServiceModule,
    AccordionComponent,
    AlertComponent,
    BadgeComponent,
    ButtonComponent,
    CardsComponent,
    DropdownComponent,
    ListGroupComponent,
    ModalComponent,
    ProgressBarComponent,
    TabComponent,
    SweetAlertComponent,
    ToastrComponent,
    DateComponent,
    InputComponent,
    SelectComponent,
    MainLayoutComponent,
    SecondaryLayoutComponent,
    SidebarComponent,
    SidebarMessageCanvasComponent,
    SidebarAnnouncementCanvasComponent,
    AnnouncementModalComponent,
    HeaderComponent,
    HeaderSecondaryComponent,
    BreadcrumbComponent,
    FooterComponent,
    ErrorComponent,
    ResourceNotFoundComponent,
    EmptyDataComponent,
    ArrayKeysPipe,
    ArrayValuesPipe,
    MinutesAgoPipe,
    FilterQ,
    SortPipe,
    DistancePipe,
    GroupByPipe,
    NgInitDirective,
    NgChangeDirective,
    FilterByPipe,
    SafeHtmlPipe,
    KeyFormatDirective,
    CoreDropdownComponent,
    CoreMultiSelectComponent,
    CoreOffcanvasComponent,
    CorePopupComponent,
    AddressAutocompleteComponent,
    FileUploadDialogComponent,
    TableComponent,
    TableModule,
    DividerModule,
    SkeletonModule,
    PaginatorModule,
    AddressInputComponent,
    MernisQueryComponent,
    LoadingComponent,
    DateFormatPipe,
    CalendarModule,
    IcdCodeListComponent,
    FilterContainerComponent,
    CoreChipsComponent,
    MultiSelectModule,
    DialogModule,
    DropdownModule,
    SidebarModule,
    CoreInfoMessagesComponent,
    ChipsModule,
    OverlayPanelModule,
    InputGroupModule,
    InputGroupAddonModule,
    PhoneNumbersComponent,
    ButtonModule,
    MedicalAdviceComponent,
    CoreAccordionComponent,
    ColorPickerModule,
    PreventNegativeInputDirective,
    EditorModule,
    ExcelComponent,
    ProgressBarModule,
    TooltipModule,
    NumberCommaFormatPipe,
    CheckboxModule,
    TreeModule,
    IcdCodesPopupComponent,
    ICDGroupComponent,
    StepsModule,
    FileUploadModule,
    PhoneListComponent,
    EmailListComponent,
    AddressListComponent,
    AlphanumericInputDirective,
    MedicalRecordsComponent,
    CurrencyFormatterDirective,
    PatientCardComponent,
    PatientCreateComponent,
    GenderPipe,
    HasPermissionDirective,
    HasPermissionPipe,
    BillStatusPipe,
    RoleAssignDetailComponent,
    TextLimiterPipe,
    GlobalSearchPipe,

    /*Logs*/
    CaseTimelineComponent,
    /*Calls*/
    CallTimerComponent,
    /*Calls*/
    CallReceivingPopupComponent,
    CallButtonComponent,
    SidebarLastCallsCanvasComponent,
    CallViewPopupComponent,
    RegionDistrictDescriptionComponent,
    PhoneMaskPipe,
    ClipboardModule,
    ServicePricePopupComponent,
    CurrencyComponent,
    GoogleAutocompleteDirective,
    TimelineModule,
    CaseAssignVehicleComponent,
    ChangeKdvRatesComponent,
    CallUploadFileComponent,
    CoreFileUploadDialogComponent,
    ReadonlyInputComponent,
    MemberInputComponent,
    InputNumberModule,
    ToggleButtonModule,
    IcdCodeDropdownComponent,
    VehicleLocationMapComponent,
    DynamicDivColorDirective,
    WatchTeamMembersCardComponent,
    OrganizationAssignVehicleComponent,
    OrganizationStatusPipe,
    CaseStatusPipe,
    AppointmentStatusPipe,
    LabmedLogsComponent,
    TooltipDirective,
    FilterByValueObjectPipe,
    CaseFeatureInformationsComponent,
    CaseFeatureInputs,
    PhoneMaskTRDirective,
    ShowOrganizationLogComponent,
    ShortcutComponent,
    MenuModule,
    CaseDocumentsComponent,
    PaymentButtonComponent,
    SendBillDocumentEmailComponent,
    SendMailSmsComponent,
    AppToggleAccordionComponent,
    AssignUserDialogComponent,
    PhonePopoverDirective,
    NgxMaskDirective,
    PatientInformationsComponent,
    PatientEmailPopupComponent,
    PatientPhonePopupComponent,
  ],
  providers: [
    AppMessageService,
    AppAlertService,
    ParameterService,
    CallService,
    provideNgxMask(),
    {provide: LOCALE_ID, useValue: 'tr'},
  ],
})
export class SharedModule {
  constructor(private readonly calendarService: CalendarLanguageService) {
  }
}

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

